<template>
    <div class="container my-4" id="work">
        <div class="card1 bg-site-gradient1 head_info p-4 mb-4 border-0 rounded-4 w-100 text-start">
            <div class="card-body p-1 d-flex align-items-center">
                <!-- <i class="fas fa-users fa-3x rounded-circle text-danger1 me-3"></i> -->
                <div class="rounded-circle me-3" style="background: url(/assets/images/authors.png) no-repeat; background-size: cover; height: 40px; width: 40px;"
                ></div>
                <h4 class="fw-bold">{{ TR.authors }}</h4>
            </div>
        </div>

        <div v-if="search_text != ''" class="card1 p-4 mb-4 border-0 rounded-4 bg-site-gradient1 w-100 text-start head_info">
            <div class="card-body p-1 d-flex flex-column flex-sm-row align-items-center">
                <div class="me-3">
                    <i class="fa fa-search fs-3"></i>
                </div>
                <div>
                    {{ TR.search_text }}: <b>{{ search_text }}</b>
                    <br>
                    {{ TR.msg_search_result }}: <b>{{ totalrecords }}</b>
                </div>
            </div>
        </div>

        <div class="row g-3">
            <div class="col-lg-8">
                <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3 mb-3">
                    <template v-for="(item, index) in authors" :key="index">
                        <div v-if="item.publish != 0" class="col card-block-authors">
                            <router-link :to="item.link" class="card h-100 work-card rounded-4 text-decoration-none text-dark">
                                <div class="card-img-top position-relative" :style="`background: url(${item.image}) no-repeat center top; background-size: cover;`"></div>
                                <div class="card-body">
                                    <h6 class="fw-semibold mb-3">{{ item.translate[0].firstname }} {{ item.translate[0].lastname }}</h6>
                                    <!-- <div class="small">
                                        <i class="far fa-envelope me-2"></i>
                                        {{ item.email }}
                                    </div> -->
                                    <div class="fw-semibold small">{{ TR.posts }}: {{ item.post_count.length }}</div>
                                    <div class="fw-semibold small">
                                        {{ TR.last_post }}:
                                        <!-- <i class="fas fa-edit"></i> -->
                                        {{ G.dateToStr(item.last_post.create_date, 'news_date', 'datetime') }}
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </template>
                </div>

                <!-- <CardH v-for="(item, index) in authors" :key="index" :data="item" :lang="TR" /> -->
            </div>
            <div class="col-lg-4">
                <HomeSidebar :data="last_posts" />
            </div>
        </div>

        <Pagination
            v-if="authors.length"
            :row_count="totalrecords"
            :pages_count="pages_count"
            :lang="TR"
            :current_page="current_page"
            :perpage="perpage"
            :page_row_count="G.rowsPerPageOptions"
            @navigate="pagenav"
            class="pagenav mt-3"
        />
    </div>
</template>


<script>
import { ref, onMounted, watchEffect } from "vue";
import { useRoute, useRouter } from 'vue-router';

import { useStore } from "@/system_modules/store";

// import CardH from '@/pages/component/CardH.vue';
import Pagination from '@/components/elements/Pagination.vue';
import HomeSidebar from '@/pages/component/HomeSidebar.vue';

import { G, ajax } from "@/_common";

export default {
    title: 'authors',
    name: "AuthorsP",
    components: {
        // CardH,
        HomeSidebar,
        Pagination,
    },
    // props:{
    //     data:{
    //         type: Object,
    //         default: {}
    //     }
    // },
    setup() {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();

        const TR = ref({});
        const authors = ref([]);
        const last_posts = ref([]);

        const pages_count = ref(0);
        const current_page = ref(null);
        const perpage = ref(15);
        const totalrecords = ref(0);
        const search_text = ref('');

		// const category_id = ref(0);
		// const author_id = ref(0);
		const route_obj = ref({});
        // const selectedFilters = ref({});
        // const selectedSortField = ref("create_date");
		// const selectedSortOrder = ref(-1);

		const page = route.params && route.params.page ? parseInt(route.params.page) : 1;
		perpage.value = route.params && route.params.perpage ? parseInt(route.params.perpage) : G.rowsPerPage;
		// category_id.value = route.params && route.params.category_id ? parseInt(route.params.category_id) : 0;
		// author_id.value = route.params && route.params.author_id ? parseInt(route.params.author_id) : 0;
		search_text.value = route.query && route.params.search_text ? route.params.search_text : '';

        // selectedSortField.value = route.params.sortfield || "create_date";
        // selectedSortOrder.value = parseInt(route.params.sortorder || -1);

        current_page.value = page;

        const pagenav = async (p, pp) => {
            perpage.value = pp;
            // if( search_text.value != '' )
            //     await getAuthors(p);
            // else
                await getAuthors(p);

            // router.push({name: 'authors_paging', params: route_obj.value});
            router.push({name: 'authors', params: route_obj.value});
        }

        const getAuthors = async (first) => {
            if( first === undefined ) first = 1;
            route_obj.value = {
                page: first,
                perpage: perpage.value,
                // category_id: parseInt(category_id.value) || 0,
                // author_name: 0,
                // author_id: parseInt(author_id.value) || 0,
                // sortfield: selectedSortField.value,
                // sortorder: selectedSortOrder.value,
                // filters: Object.keys(selectedFilters.value).filter((k) => selectedFilters.value[k] == true).join(',') || '0',
                search_text: search_text.value || '',
			};
        };

        watchEffect(() => {
            TR.value = store.getTranslation();
        });

        onMounted(async () => {
            await getAuthors(page);

            await ajax({
                loading: true,
                // url: store.getAuthors(route_obj.value), // + `?rows=${perpage.value}&first=${(first-1)*perpage.value}&search_text=${encodeURIComponent(search_text.value)}`,
                url: store.getAuthorsPaging(route_obj.value), // + `?rows=${perpage.value}&first=${(first-1)*perpage.value}&search_text=${encodeURIComponent(search_text.value)}`,
                success: (e) => {
                    authors.value = e.data.data;
                    authors.value.forEach(a => {
                        // a.link = {'name': 'post_paging', params: { page: 1, perpage: G.rowsPerPage, category_id: 0, author_id: a.id || 0, sortfield: 'create_date', sortorder: -1, filters: '0', search_text: '' } };
                        // a.link = {'name': 'author_paging', params: { page: page, perpage: G.rowsPerPage, author_name: a.username, author_id: a.id || 0 } };
                        a.link = {'name': 'author_detail', params: { author_id: a.id || 0, author_name: a.username.replaceAll('.', '_') } };
                        // a.last_post.create_date = new Date(a.last_post.create_date);
                        // console.log(a.last_post.create_date);
                    });
                    totalrecords.value = e.data.total_records;
                    pages_count.value = Math.ceil(e.data.total_records / perpage.value);
                }
            });

            await ajax({
                url: store.getAuthor(),
                success: (e) => {
                    last_posts.value = e.data.data;
                }
            });

        });

        return {
            G,
            TR,
            authors,
            pagenav,
            pages_count,
            totalrecords,
            current_page,
            perpage,
            last_posts,
            search_text
        };
    },
};
</script>


<style lang="scss">
.card-block-authors{
    .card {
        border: 1px solid var(--card-border-color);
        transition: box-shadow .3s;
    }

    .card-img-top {
        border-radius: 1rem 1rem 0 0;
        height: 250px;
    }

    .card:hover {
        box-shadow: 0 0 21px rgba(33, 33, 33, .2);
        cursor: pointer;
        scale: 1.01;
    }

    .card a {
        color: rgb(var(--site-primary-color-rgb));
    }

}
.head_info{
    box-shadow: var(--shadow);
}
</style>
